import { ProviderGroupControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useStatusProviderGroup = () =>
  useMutationWithLoading(async (param: { depId: string; status: boolean }) =>
    new ProviderGroupControllerApi(getConfigObject()).updateProviderGroupStatus(
      param.depId,
      param.status,
      undefined //xTENANTID
    )
  );
